import type { ModalProviderState } from './ModalProvider.types'

export const INITIAL_MODAL_STATE: ModalProviderState = {
  component: null,
  isOpen: false,
  props: {},
}
